module.exports = __webpack_public_path__ + "static/logo-fc426a0b2d7397e0c298407de8bcff00.png";